import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// MOCK PayPal approval page, used only while PayPal credentials are not configured
export default function MockCheckout() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { user } = useAuth();
  const subId = params.get("subscription_id");
  const yearly = params.get("interval") === "year";
  const trial = params.get("trial") === "1";
  const price = yearly ? "$90.00 USD / year" : "$9.00 USD / month";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f7fa] px-6 text-[#1a1a1a]" data-testid="mock-checkout-page">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-md p-8">
        <p className="text-[11px] font-bold tracking-widest text-[#c0392b] uppercase" data-testid="mock-checkout-banner">Mock PayPal checkout · no real charge</p>
        <p className="text-2xl font-bold italic mt-3"><span className="text-[#003087]">Pay</span><span className="text-[#009cde]">Pal</span></p>
        <div className="mt-6 border rounded p-4 text-sm space-y-1">
          <p className="font-semibold">Vox Nocturna Pro · {yearly ? "Yearly" : "Monthly"}</p>
          {trial ? (
            <p data-testid="mock-checkout-terms">7 days free, then {price}</p>
          ) : (
            <p data-testid="mock-checkout-terms">{price} · starts today</p>
          )}
          <p className="text-gray-500">Account: {user?.email}</p>
          <p className="text-gray-400 text-xs">Subscription {subId}</p>
        </div>
        <button
          data-testid="mock-checkout-approve-btn"
          onClick={() => nav(`/billing/return?subscription_id=${encodeURIComponent(subId)}`, { replace: true })}
          className="w-full mt-6 bg-[#ffc439] hover:bg-[#f2ba36] rounded-full py-3 font-semibold transition-colors"
        >
          Agree & Subscribe
        </button>
        <button data-testid="mock-checkout-cancel-btn" onClick={() => nav("/#pricing", { replace: true })} className="w-full mt-3 text-sm text-[#0070ba] hover:underline">
          Cancel and return to Vox Nocturna
        </button>
      </div>
    </div>
  );
}
